import { gql } from '@apollo/client'

export const UPDATE_FUEL_TYPE = gql`
  mutation updateFuelType($input: UpdateFuelTypeInput!) {
    data: updateFuelType(input: $input) {
      id
    }
  }
`
